import { Controller } from "@hotwired/stimulus"

// Client-side tab switching for the Beam robot dashboard show page.
// Adapted from settings_tabs_controller.js without the URL-rewriting logic.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { currentTab: { type: String, default: "overview" } }

  connect() {
    this.showTab(this.currentTabValue)
  }

  switch(event) {
    event.preventDefault()
    this.goToTab(event.currentTarget.dataset.tab)
  }

  // Public helper so in-panel buttons (e.g. "Zum Live-Feed wechseln") can jump tabs.
  goToTab(tabName) {
    if (!tabName) return
    this.currentTabValue = tabName
    this.showTab(tabName)
  }

  showTab(tabName) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tab === tabName
      tab.classList.toggle("border-gray-900", active)
      tab.classList.toggle("text-gray-900", active)
      tab.classList.toggle("font-semibold", active)
      tab.classList.toggle("border-transparent", !active)
      tab.classList.toggle("text-gray-500", !active)
      tab.classList.toggle("hover:text-gray-700", !active)
      tab.setAttribute("aria-current", active ? "page" : "false")
    })

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tab !== tabName)
    })
  }
}
